module.exports = __webpack_public_path__ + "static/media/malrose.966dfe13.png";